module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-9.b5f2ee1c.png";